import React, { useState } from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { motion } from "framer-motion";
import colors from "../../constants/colors";

//Assets
import arrow_down from "../../assets/icons/arrow_down.svg";
import { MOBILE } from "../../constants/breakpoints";

function Faq() {
  return (
    <section
      css={css`
        display: flex;
        flex-direction: column;
        width: 1140px;
        margin: 0 auto;
        @media (max-width: ${MOBILE}px) {
          width: 90%;
          align-items: center;
          margin: 0 auto;
        }
      `}
    >
      <h1
        css={css`
          font-weight: 700;
          font-size: 56px;
          margin: 0;

          @media (max-width: ${MOBILE}px) {
            font-weight: 700;
            font-size: 32px;
          }
        `}
      >
        Frequently Asked Questions
      </h1>
      {/* <p
        css={css`
          font-weight: 500;
          font-size: 16px;
          @media (max-width: ${MOBILE}px) {
            font-weight: 400;
            font-size: 14px;
          }
        `}
      >
        Lorem Ipsum is simply dummy text of the printing and typesetting
        industry.
      </p> */}

      <div
        css={css`
          display: flex;
          flex-direction: column;
          margin-top: 100px;

          @media (max-width: ${MOBILE}px) {
            margin-top: 80px;
            width: 100%;
            row-gap: 30px;
          }
        `}
      >
        <FaqElement
          qn={"What is Proxy Token?"}
          ans={
            "Technically proxy contracts work the same way as smart contracts. They are self-executing, business automation applications that run on a decentralized network such as blockchain. Such contracts run when predetermined conditions are met."
          }
        />
        <FaqElement
          qn={"What is Asset Wallet ? How it works?"}
          ans={
            "Technically proxy contracts work the same way as smart contracts. They are self-executing, business automation applications that run on a decentralized network such as blockchain. Such contracts run when predetermined conditions are met."
          }
        />
        <FaqElement
          qn={"Where can I get some?"}
          ans={
            "Technically proxy contracts work the same way as smart contracts. They are self-executing, business automation applications that run on a decentralized network such as blockchain. Such contracts run when predetermined conditions are met."
          }
        />
        <FaqElement
          qn={"Where does it come from?"}
          ans={
            "Technically proxy contracts work the same way as smart contracts. They are self-executing, business automation applications that run on a decentralized network such as blockchain. Such contracts run when predetermined conditions are met."
          }
        />
      </div>
    </section>
  );
}

const FaqElement = ({ qn, ans }: { qn: string; ans: string }) => {
  const [toggleFaq, settoggleFaq] = useState<boolean>(false);

  return (
    <div>
      <span
        css={css`
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
        `}
        onClick={() => {
          settoggleFaq((t) => !t);
        }}
      >
        <h2
          css={css`
            margin: 0;
            font-weight: 700;
            font-size: 24px;

            @media (max-width: ${MOBILE}px) {
              font-weight: 700;
              font-size: 16px;
            }
          `}
        >
          {qn}
        </h2>
        <motion.img
          initial={{ rotate: 0 }}
          animate={toggleFaq ? { rotate: 180 } : { rotate: 0 }}
          transition={{ ease: "easeOut", duration: 0.4 }}
          src={arrow_down}
          alt=""
        />
      </span>
      {toggleFaq && (
        <motion.p
          initial={{ opacity: 0, scale: 0.97 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ ease: "easeOut", duration: 0.4 }}
          css={css`
            margin: 0;
            margin-top: 16px;
            font-weight: 500;
            font-size: 16px;
            line-height: 150%;
            width: 60%;

            @media (max-width: ${MOBILE}px) {
              font-weight: 400;
              font-size: 14px;
              width: 100%;
            }
          `}
        >
          {ans}
        </motion.p>
      )}

      <span
        css={css`
          display: flex;
          width: 100%;
          height: 1px;
          background-color: ${colors.INTERFACE_COLORS_DARK_STONE};
          opacity: 0.3;
          margin-top: 16px;
          margin-bottom: 24px;
        `}
      ></span>
    </div>
  );
};

export default Faq;
